export default __webpack_public_path__ + "static/media/Avatar-31.803afc1a.svg";